import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const StickyHeader = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Show header after scrolling past the first viewport height (Hero section)
            if (window.scrollY > window.innerHeight * 0.8) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // Check on mount

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToFooter = () => {
        const footer = document.querySelector('[data-testid="footer-section"]');
        if (footer) {
            footer.scrollIntoView({ behavior: 'smooth' });
        } else {
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        }
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.header
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4, ease: 'easeOut' }}
                    className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 pointer-events-none"
                >
                    {/* Subtle top gradient to ensure button contrast if needed */}
                    <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-transparent pointer-events-none" />

                    <div className="flex-1 pointer-events-auto">
                        <img src="/logo.png" alt="Neuron Logo" className="h-8 w-auto object-contain" />
                    </div>

                    <button
                        onClick={scrollToFooter}
                        className="pointer-events-auto relative overflow-hidden bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.1)] hover:border-[rgba(255,255,255,0.2)] text-[#EDEDED] px-6 py-2.5 rounded-full text-xs font-mono uppercase tracking-[0.15em] transition-all duration-300 backdrop-blur-md shadow-[0_4px_20px_rgba(0,0,0,0.5)] group"
                    >
                        <span className="relative z-10 flex items-center gap-2">
                            <span className="w-1.5 h-1.5 rounded-full bg-[#8B5CF6] shadow-[0_0_8px_#8B5CF6] group-hover:bg-white group-hover:shadow-[0_0_8px_white] transition-colors duration-300" />
                            Join Waitlist
                        </span>
                        <div className="absolute inset-0 bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </button>
                </motion.header>
            )}
        </AnimatePresence>
    );
};

export default StickyHeader;
